import gql from 'graphql-tag'

export const DELETE_DIVISION = gql`
  mutation deleteDivision($divisionId: ID!) {
    deleteDivision(divisionId: $divisionId) {
      success
    }
  }
`



// WEBPACK FOOTER //
// ./src/mutations/DeleteDivision.tsx